var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 25,
    fill: "#3141D0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 39,
    width: 21,
    height: 3,
    fill: "#3141D0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 85,
    width: 21,
    height: 3,
    fill: "#3141D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5341 63.7273C84.5341 68.6364 83.6477 72.8788 81.875 76.4545C80.1023 80.0303 77.6705 82.7879 74.5795 84.7273C71.4886 86.6667 67.9583 87.6364 63.9886 87.6364C60.0189 87.6364 56.4886 86.6667 53.3977 84.7273C50.3068 82.7879 47.875 80.0303 46.1023 76.4545C44.3295 72.8788 43.4432 68.6364 43.4432 63.7273C43.4432 58.8182 44.3295 54.5758 46.1023 51C47.875 47.4242 50.3068 44.6667 53.3977 42.7273C56.4886 40.7879 60.0189 39.8182 63.9886 39.8182C67.9583 39.8182 71.4886 40.7879 74.5795 42.7273C77.6705 44.6667 80.1023 47.4242 81.875 51C83.6477 54.5758 84.5341 58.8182 84.5341 63.7273ZM79.0795 63.7273C79.0795 59.697 78.4053 56.2955 77.0568 53.5227C75.7235 50.75 73.9129 48.6515 71.625 47.2273C69.3523 45.803 66.8068 45.0909 63.9886 45.0909C61.1705 45.0909 58.6174 45.803 56.3295 47.2273C54.0568 48.6515 52.2462 50.75 50.8977 53.5227C49.5644 56.2955 48.8977 59.697 48.8977 63.7273C48.8977 67.7576 49.5644 71.1591 50.8977 73.9318C52.2462 76.7045 54.0568 78.803 56.3295 80.2273C58.6174 81.6515 61.1705 82.3636 63.9886 82.3636C66.8068 82.3636 69.3523 81.6515 71.625 80.2273C73.9129 78.803 75.7235 76.7045 77.0568 73.9318C78.4053 71.1591 79.0795 67.7576 79.0795 63.7273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtto);
export default __webpack_public_path__ + "static/media/Otto.58f95fdf24fc5a15245b3be7b8fa08cb.svg";
export { ForwardRef as ReactComponent };